import styled from "styled-components";

import editImg from "../../images/icon_edit.svg";
import { TOOLTIPS } from "../../utils/tooltipConstants";
import { BaseButton, TooltipBox } from "./BaseButton";

const IconButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.colors.primaryBlue};
  & :hover > ${TooltipBox} {
    background-color: ${({ theme }) => theme.colors.primaryBlue};
  }
  :disabled,
  [disabled] {
    background-color: ${({ theme }) =>
      theme.colors.primaryBlue + theme.transparencies.p30};
    border-color: ${({ theme }) =>
      theme.colors.primaryBlue + theme.transparencies.p10};
  }
`;

export function EditButton(props: any) {
  const { onClick, disabled, tooltipText } = props;
  const tooltipContent = tooltipText ? tooltipText : TOOLTIPS.edit.text;
  return (
    <IconButton onClick={onClick} disabled={disabled} tooltip={tooltipContent}>
      <img src={editImg} alt={tooltipContent} />
    </IconButton>
  );
}
